module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid4_800x600.39eb958.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid4_800x600.jpg
// module id = o6fO
// module chunks = 0